import { action, makeObservable, observable, runInAction } from "mobx";
import { Carrier, ListCarriersParams } from "../../../models/Carriers/Carrier";
import { FilterValue } from "../../../models/Filters/FilterValue";
import CarriersAPI from "../api/CarriersAPI";

export class CarriersStore {
  carriersAPI: CarriersAPI;
  carriers: Carrier[] = [];
  loading = false;
  error: string | null = null;
  private listRequestId = 0;

  constructor() {
    this.carriersAPI = new CarriersAPI();

    makeObservable(this, {
      carriers: observable,
      loading: observable,
      error: observable,
      listCarriers: action,
    });
  }

  listCarriers = async (params?: ListCarriersParams) => {
    const requestId = ++this.listRequestId;
    this.loading = true;
    this.error = null;

    try {
      const result = await this.carriersAPI.listCarriers({
        page_no: 1,
        limit: 200,
        is_active: 1,
        ...params,
      });

      runInAction(() => {
        if (requestId !== this.listRequestId) {
          return;
        }
        this.carriers = result.list;
        this.loading = false;
      });
    } catch (error: any) {
      runInAction(() => {
        if (requestId !== this.listRequestId) {
          return;
        }
        this.carriers = [];
        this.error =
          error?.response?.data?.message ||
          error?.message ||
          "Failed to load delivery partners.";
        this.loading = false;
      });
    }
  };

  toDropdownList = (): FilterValue[] =>
    this.carriers.map((carrier) => ({
      id: String(carrier.id),
      value: carrier.name,
      subtitle: carrier.code,
    }));
}
